import { useGame } from '../context/GameContext';
import { useOnlineTurn } from '../context/hooks/useOnlineTurn';
import type { GameState } from '../types/game';

type TurnSegment = NonNullable<GameState['segments']>[number];

function DebugSegmentsPanel() {
  const { gameState } = useGame();
  const { potential } = useOnlineTurn();
  const turnCycle = gameState.turnCycle;
  const segments = gameState.segments || [];
  const capturedMask = turnCycle?.capturedMask || [];
  const kept = turnCycle?.kept || [];

  const data = {
    activePlayerId: turnCycle?.activePlayerId,
    rollCount: turnCycle?.rollCount,
    dice: turnCycle?.dice,
    kept,
    capturedMask,
    segments,
    potential,
  };

  function copy() {
    try { navigator.clipboard.writeText(JSON.stringify(data, null, 2)); } catch {}
  }

  return (
    <div
      className="fixed right-2 z-50 bg-black/80 text-xs text-green-200 p-3 rounded-sm shadow-lg w-72 max-h-[70vh] overflow-auto font-mono space-y-2"
      style={{ bottom: 'calc(0.5rem + var(--app-safe-area-bottom))' }}
      data-testid="debug-segments-panel"
    >
      <div className="flex items-center justify-between">
        <strong className="text-green-300">Segments Debug</strong>
        <button onClick={copy} className="px-2 py-0.5 bg-green-700/40 hover:bg-green-600/40 rounded-sm">Copy</button>
      </div>
      <div>
        <div>Active: {data.activePlayerId || '-'}</div>
        <div>Rolls: {data.rollCount}</div>
        <div>Dice: {JSON.stringify(data.dice)}</div>
        <div>Kept: {JSON.stringify(kept)}</div>
        <div>Captured: {JSON.stringify(capturedMask)}</div>
        <div>Potential: {potential ? `${potential.points} (${potential.scoringDice})` : 'null'}</div>
      </div>
      <div className="border-t border-green-600/40 pt-1">
        {segments.length === 0 && <div className="opacity-60">(no segments)</div>}
        {segments.map((s: TurnSegment, i: number) => (
          <div key={i} className="mb-1">
            <div className="text-green-400">#{i+1}: {s.points} pkt / {s.scoringDiceCount}k</div>
            <div className="truncate">{JSON.stringify(s.dice)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function DebugSegmentsEntry() {
  if (typeof window === 'undefined') return null;
  if (!window.__DICE_DEBUG_SEGMENTS__) return null;
  return <DebugSegmentsPanel />;
}
